import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["usageTracker"];
import styled from 'styled-components';
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import { NOT_USING_TRACKER } from 'ai-components-ui-library/hooks/useTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const SizeRestrictedBreezeButton = styled(AIButton).attrs(({
  use = 'tertiary'
}) => ({
  use,
  showBreezeIcon: false
})).withConfig({
  displayName: "SizeRestrictedButton__SizeRestrictedBreezeButton"
})(["max-width:200px !important;width:fit-content !important;&:hover{color:", " !important;border-color:", " !important;background:", " !important;}&:active{color:", " !important;border-color:", " !important;background:", " !important;}"], ({
  theme
}) => theme.color['text-tertiary-default'], ({
  theme
}) => theme.color['text-tertiary-default'], ({
  theme
}) => theme.color['fill-tertiary-hover'], ({
  theme
}) => theme.color['text-tertiary-default'], ({
  theme
}) => theme.color['text-tertiary-default'], ({
  theme
}) => theme.color['fill-tertiary-pressed']);
const SizeRestrictedButton = _ref => {
  let {
      usageTracker = NOT_USING_TRACKER
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(SizeRestrictedBreezeButton, Object.assign({
    size: "xs"
  }, buttonProps, {
    usageTracker: usageTracker
  }));
};
export default SizeRestrictedButton;